import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyManagementComponent } from './property-management.component';
import { RouterModule, Routes } from '@angular/router';
import { AddPropertyComponent } from './add-property/add-property.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseModule } from 'src/app/core/base/base.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { SaCardModule } from 'src/app/components/sa-card/sa-card.module';
import { InfoCardModule } from 'src/app/components/info-card/info-card.module';
import { ClientDocumentUploaderModule } from 'src/app/shared/components/clientDocumentUploader/clientDocument-uploader.module';
import { FileUploadModule } from 'ng2-file-upload';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PageHeaderModule } from 'src/app/shared/components/page-header/page-header.module';
import { ContentCardModule } from 'src/app/shared/components/content-card/content-card.module';
import { CardDialogModule } from 'src/app/shared/components/card-dialog/card-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MeterManagementModule } from '../meter-management/meter-management.module';
import { QrBookletModule } from '../qr-booklet/qr-booklet.module';
import { HttpInterceptorService } from 'src/app/core/services/http-interceptor-service';
import { PropertyStructureModule } from '../property-structure/property-structure.module';
import { TargetDatesModule } from '../target-dates/target-dates.module';

const routes: Routes = [
  {
      path: '',
      component: PropertyManagementComponent,
      data: { breadcrumb: {
        label: 'Home'
      }}
  }
];

@NgModule({
  declarations: [
    PropertyManagementComponent,
    AddPropertyComponent
  ],
  imports: [
    CommonModule,
    BaseModule,
    RouterModule.forChild(routes),
    MaterialModule,
    SaCardModule,
    InfoCardModule,
    ClientDocumentUploaderModule,
    FileUploadModule,
    MatDialogModule,
    PageHeaderModule,
    ContentCardModule,
    CardDialogModule,
    MatTooltipModule,
    PropertyStructureModule,
    MeterManagementModule,
    QrBookletModule,
    TargetDatesModule,
  ],
  exports: [
    AddPropertyComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: MatDialogRef,
      useValue: {}
    },
  ],
})
export class PropertyManagementModule { }
